import { AxiosResponse } from 'axios'

import { Request } from './request'

export abstract class AbstractApi {
  protected async get<T>(path: string, params: Record<string, any> = {}, headers: Record<string, any> = {}): Promise<AxiosResponse<T>> {
    return Request<T>('get', path, undefined, params, headers)
  }

  protected async post<T>(path: string, data: object, headers: Record<string, any> = {}): Promise<AxiosResponse<T>> {
    return Request('post', path, data, {}, headers)
  }

  protected async put<T>(path: string, data: object, headers: Record<string, any> = {}): Promise<AxiosResponse<T>> {
    return Request('put', path, data, {}, headers)
  }

  protected async patch<T>(path: string, data: object, headers: Record<string, any> = {}): Promise<AxiosResponse<T>> {
    return Request('patch', path, data, {}, headers)
  }

  protected async delete<T>(path: string, headers: Record<string, any> = {}): Promise<AxiosResponse<T>> {
    return Request('delete', path, undefined, {}, headers)
  }
}
